/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import Banner from "./features/banner";

const CreateBot = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <Banner />
        </section>
      </Layout>
    </>
  );
};
export default CreateBot;
